import CONTENTO_TYPES from '../domain/ContentoTypes';
import VideoTypes from '../domain/VideoTypes';
import get from './get';
import { createClipUrlFromContento } from './urlUtil';

export function transformContentType(type) {
    switch (type) {
        case CONTENTO_TYPES.SINGLE:
            return VideoTypes.SINGLE;
        case CONTENTO_TYPES.EPISODE:
        case CONTENTO_TYPES.VARIANT:
            return VideoTypes.EPISODE;
        case CONTENTO_TYPES.TVSERIES:
        case CONTENTO_TYPES.TVSHOW:
            return VideoTypes.TITLE;
        case CONTENTO_TYPES.CLIP:
        case CONTENTO_TYPES.TRAILER:
            return VideoTypes.CLIP;
        default:
            return VideoTypes.TITLE;
    }
}

export const filterItems = (items, filterAbroad) => {
    return items.filter((item) => {
        if (filterAbroad && item.item.restrictions.onlyAvailableInSweden) {
            return false;
        }

        return true;
    });
};

export const getContentUrl = (item, currentAccessibilityChoiceContento) => {
    const accessibilityVariant = (item.variants || item.episode?.variants || []).find((variant) => {
        return variant.accessibility === currentAccessibilityChoiceContento;
    });

    if (accessibilityVariant) {
        return accessibilityVariant.urls.svtplay;
    }

    return item.urls ? item.urls.svtplay : createClipUrlFromContento(item.id, item.name);
};

export const getContentSvtId = (item, currentAccessibilityChoiceContento) => {
    const accessibilityVariant = (item.variants || item.episode?.variants || []).find((variant) => {
        return variant.accessibility === currentAccessibilityChoiceContento;
    });

    if (accessibilityVariant?.svtId) {
        return accessibilityVariant.svtId;
    }

    return item.svtId;
};

export function getContentoVideoId(item, currentAccessibilityChoiceContento) {
    const accessibilityVariant = (item.variants || item.episode?.variants || []).find(
        (variant) => variant.accessibility === currentAccessibilityChoiceContento
    );

    if (accessibilityVariant) {
        return accessibilityVariant.videoSvtId;
    }

    return item.videoSvtId;
}

export const generateListTracking = (selection) => {
    return {
        listType: get(selection, 'analyticsIdentifiers.listType'),
        listID: get(selection, 'analyticsIdentifiers.listId'),
    };
};

export function isProbablyEscenicId(id) {
    if (id) {
        return String(id).match(/^\d+$/gi) !== null;
    }

    return false;
}
